<template>
  <div class='detail-data-page'>
    <!-- 左侧 -->
    <CarrierList :getList='detailList' :getSave='[]'></CarrierList>
    <!-- 中 -->
    <div class='middle-content'>
      <Condition :carrierList='carrierList' :form='condition'></Condition>
      <PointList :carrierList.sync='carrierList' :condition='condition'></PointList>
    </div>
    <!-- 右 -->
    <RightContent :form='condition' />
  </div>
</template>

<script>
import bus from '@/utils/bus'
import CarrierList from '@/components/CarrierList/CarrierList.vue'
import Condition from './condition/condition.vue'
import PointList from './pointList/pointList.vue'
import RightContent from './RightContent.vue'
import moment from 'moment'
import { detailList } from '@/api/modules/dataDetail.js'
import { getIsGuide } from '@/utils/guide'
import { mockGetSelectedMonitor } from '@/common/driver/modules/count/mock'

export default {
  components: {
    CarrierList,
    Condition,
    PointList,
    RightContent
  },
  computed: {
    detailList: () => detailList
  },
  data () {
    return {
      carrierList: [],
      condition: {
        start: moment(new Date()).subtract(1, 'hours').valueOf(),
        end: new Date().getTime(),
        data: ['0'],
        file: '0'
      }
    }
  },
  mounted () {
    if (getIsGuide()) {
      this.carrierList = mockGetSelectedMonitor()
    }
    // 绑定事件接收数据
    bus.$on('selectRows', (rows, checked) => {
      this.carrierList = rows
    })
  },
  beforeDestroy () {
    bus.$off('selectRows')
  }
}
</script>

<style lang='scss' scoped>
.detail-data-page {
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;

  .middle-content {
    width: 300px;
    height: 100%;
    border: 1px solid #ccc;
    border-left: 0;
    box-sizing: border-box;
  }
}
</style>
